import WPPagination from "./WPPagination";

export default WPPagination;
